// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media only screen and (max-width: 1000px)
{

    .feeTableContainer
    {
        display: flex;  
        width: 100%;
        margin: 0;
        overflow-x: scroll; /* Enable horizontal scrolling for mobile */
        scroll-snap-type: x mandatory;
        /* white-space: nowrap; */
    }
    .columns {
        
        flex: 1 1;
        min-width: 100%; /* Each section takes up the full width */
        padding: 20px;
        background-color: #f0f0f0;
        border: 1px solid #ccc;
        text-align: center;
        transition: transform 0.3s ease-in-out; /* Add slide transition */
        min-width: 100%; /* Each section takes up the full width */
        scroll-snap-align: start;

      }
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/components/FeeStructure.css"],"names":[],"mappings":";AACA;;;IAGI;;QAEI,aAAa;QACb,WAAW;QACX,SAAS;QACT,kBAAkB,EAAE,2CAA2C;QAC/D,6BAA6B;QAC7B,yBAAyB;IAC7B;IACA;;QAEI,SAAO;QACP,eAAe,EAAE,yCAAyC;QAC1D,aAAa;QACb,yBAAyB;QACzB,sBAAsB;QACtB,kBAAkB;QAClB,sCAAsC,EAAE,yBAAyB;QACjE,eAAe,EAAE,yCAAyC;QAC1D,wBAAwB;;MAE1B;AACN","sourcesContent":["\n@media only screen and (max-width: 1000px)\n{\n\n    .feeTableContainer\n    {\n        display: flex;  \n        width: 100%;\n        margin: 0;\n        overflow-x: scroll; /* Enable horizontal scrolling for mobile */\n        scroll-snap-type: x mandatory;\n        /* white-space: nowrap; */\n    }\n    .columns {\n        \n        flex: 1;\n        min-width: 100%; /* Each section takes up the full width */\n        padding: 20px;\n        background-color: #f0f0f0;\n        border: 1px solid #ccc;\n        text-align: center;\n        transition: transform 0.3s ease-in-out; /* Add slide transition */\n        min-width: 100%; /* Each section takes up the full width */\n        scroll-snap-align: start;\n\n      }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
